import { jsx as _jsx } from "react/jsx-runtime";
import { CopyTypography } from '../CopyTypography';
import { DescriptionDetailsStyled } from './DescriptionList.styled';
export const DescriptionDetails = ({ copy, children }) => {
    if (copy)
        return (_jsx(DescriptionDetailsStyled, { children: _jsx(CopyTypography, { children: children }) }));
    return _jsx(DescriptionDetailsStyled, { children: children });
};
